module.exports = __webpack_public_path__ + "img/Group 940.6a53dab1.svg";